import React from 'react';
import { checkAll, checkMax, checkMoney, Container, Popup } from '@ivorobioff/shared';
import { Controller, useForm } from 'react-hook-form';
import { Subject } from 'rxjs';
import { TextField } from '@material-ui/core';
import DebtOperationService from '../../../services/DebtOperationService';
import Debt from '../../../models/Debt';

export interface PaybackPopupProps {
  debt: Debt;
  onClose: () => void;
  container: Container;
  onTransfer: (debt: Debt) => void;
}

interface FormData {
  amount: number;
}

export function PaybackPopup({ container, onClose, onTransfer, debt }: PaybackPopupProps) {
  const debtOperationService = container.get(DebtOperationService);

  const { control, handleSubmit } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      amount: debt.amount,
    }
  });

  return <Popup
    onHandle={() => {
      const subject = new Subject<boolean>();

      const done = (ok: boolean) => {
        subject.next(!ok);
        subject.complete();
      };

      handleSubmit(async ({ amount }) => {
        amount = Number(amount);

        const paidback = await debtOperationService.payback(debt, amount);

        onTransfer(paidback.debt);
        done(true);
      }, () => done(false))();

      return subject.asObservable();
    }}
    onClose={onClose}
    submitButtonTitle="Transfer"
    cancelButtonTitle="Cancel"
    open={true}
    title="Payback">

    <form>
      <Controller name="amount" control={control}
        rules={{
          validate: checkAll(checkMoney, (v) => checkMax(v, debt.amount)),
        }}
        render={({ field, fieldState: { invalid, error } }) =>
          <TextField label="Amount"
            fullWidth
            error={invalid}
            helperText={error?.message}
            {...field} />} />
    </form>
  </Popup>;
}